/*

    Module: jv.search.url-redirect.service
    Service: jvSearchUrlRedirectService

    Used to set search parameters and redirect to new application search.

    This is a singleton object.

    Usage:

        jvSearchUrlRedirectService.setSourceObj('718a38y');
        jvSearchUrlRedirectService.setWorkflow('New');
        jvSearchUrlRedirectService.redirect();

 */

angular.module('jv.search.url-redirect.service', [
    require('./jv.search.serializer.service')
])
.service('jvSearchUrlRedirectService', [
    'jvSearchSerializer', '$window', '$filter', '$http',
    function(jvSearchSerializer, $window, $filter, $http) {
        var data = {};
        var dateFilter = $filter('date');
        var saveFormat = 'yyyy-MM-dd';

        this.setLastUpdated = function(start, end) {
            data.lastUpdated = {
                from: dateFilter(start, saveFormat),
                to: dateFilter(end, saveFormat),
                type: 'custom'
            };
        };

        this.setApplicationDate = function(start, end) {
            data.appliedDate = {
                from: dateFilter(start, saveFormat),
                to: dateFilter(end, saveFormat),
                type: 'custom'
            };
        };

        // deprecated
        this.setSource = function(sourceId) {
            if (sourceId !== 'All') {
                data.sourceId = sourceId;
            }
        };

        var getSourceBySourceId = function (sourceId, sourceTypes) {
            if (angular.isDefined(sourceTypes)) {
                for(var sourceIndex in sourceTypes){
                    if(sourceTypes[sourceIndex].name === sourceId){
                        return sourceTypes[sourceIndex].EId;
                    }
                }
            }
        };

        this.setSourceId = function (sourceId,callback) {
            if (sourceId !== 'All') {
                $http.get('/jhire/action/application/sourceTypes')
                    .then(function(response) {
                        var sourceEId = getSourceBySourceId(sourceId, response.data.sourceTypes);
                        data.sourceId = {
                            'ids':sourceEId.split()
                        };
                        callback();
                });
            }else{
                callback();
            }
        };

        this.setSourceObj = function(sourceId) {
            data.sourceId = data.sourceId || {};
            (data.sourceId.ids = data.sourceId.ids || []).push(sourceId);
        };

        this.setRequisition = function(requisitionId, requisitionName) {
            data.jobs = {
                reqEId: requisitionId,
                reqName: requisitionName
            };
        };

        this.setRequisitionType = function(typeId) {
            data.jobs = parseInt(typeId);
        };

        this.setWorkflow = function(workflowStateId) {
            (data.workflowStateId = data.workflowStateId || []).push(workflowStateId);
        };

        this.setRegion = function(regionId, regionName) {
            (data.region = data.region || []).push({
                EId: regionId,
                name: regionName
            });
        };

        this.setCompany = function(companyId, companyName) {
            (data.companies = data.companies || []).push({
                EId: companyId,
                name: companyName
            });
        };

        this.setJobLocation = function(jobLocationId, jobLocationName) {
            (data.jobLocation = data.jobLocation || []).push({
                EId: jobLocationId,
                name: jobLocationName
            });
        };

        this.setPostingType = function(postingTypeId) {
            (data.postingType = data.postingType || []).push(parseInt(postingTypeId));
        };

        this.setJobType = function(jobTypeId) {
            (data.jobTypeId = data.jobTypeId || []).push(jobTypeId);
        };

        this.setDepartment = function(departmentId, departmentName) {
            (data.department = data.department || []).push({
                EId: departmentId,
                name: departmentName
            });
        };

        this.setCategory = function(categoryId, categoryName) {
            (data.category = data.category || []).push({
                EId: categoryId,
                name: categoryName
            });
        };

        this.setHiringManagers = function(hiringManagerId, hiringManagerName) {
            (data.hiringManagers = data.hiringManagers || []).push({
                EId: hiringManagerId,
                fullName: hiringManagerName
            });
        };

        this.setRecruiters = function(recruiterId, recruiterName) {
            (data.recruiters = data.recruiters || []).push({
                EId: recruiterId,
                fullName: recruiterName
            });
        };

        this.setKeyword = function(keyword, type) {
            type = type || 'all';
            data.searchType = type;
            data.keywords = keyword;
        };

        this.setCollection = function(collectionId, collectionName) {
            data.collections = {
                EId: collectionId,
                name: collectionName
            };
        };

        this.setFromParams = function(params) {
            if (params.q) {
                this.setKeyword(params.q);
            }
            if (params.workflowStateIds) {
                if (params.workflowStateIds === '-1') {
                    this.setWorkflow(Number(params.workflowStateIds));
                }
                else {
                    this.setWorkflow(params.workflowStateIds);
                }
            }
            if (params.jobIds && params.jobName) {
                this.setRequisition(params.jobIds, params.jobName);
            }
            if (params.collectionIds && params.collectionName) {
                this.setCollection(params.collectionIds, params.collectionName);
            }
        };

        this.reset = function() {
            data = {};
        };

        this.getUrl = function() {
            var url = $window.jvUrls.jhire + '/modules/candidates/search.html#/q/';
            url += this.getEncodedData();
            return url;
        };

        this.getEncodedData = function() {
            return jvSearchSerializer.serialize(data);
        };

        this.redirect = function() {
            $window.location = this.getUrl();
        };
    }
]);
